/**
 * 阿里图标库地址
 * 项目地址: https://www.iconfont.cn/manage/index?spm=a313x.home_index.i3.22.58a33a81W1HEkv&manage_type=myprojects&projectId=4400356
 * 选择symbol，然后复制链接即可
 */
export const AliIconfontUrl = "//at.alicdn.com/t/c/font_4400356_syujfo50f.js";
